import React, {useState} from "react";
import SearchSelectorCategoryIcon from "../../../../../components/searchSelector/SearchSelectorCategoryIcon";

function ChevronIcon({open}) {
    return (
        <svg
            className={`search-selector-filter-chevron ${open ? "is-open" : ""}`}
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden
        >
            <path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
    );
}

function FilterTreeNodes({nodes, depth, selectedDeptId, expandedNodeIds, onToggleNode, onSelect}) {
    if (!nodes?.length) return null;

    return nodes.map((node) => {
        const nodeKey = `dept:${node.id}`;
        const hasChildren = Array.isArray(node.children) && node.children.length > 0;
        const isExpanded = !!expandedNodeIds[nodeKey];
        const isSelected = selectedDeptId === node.id;

        return (
            <React.Fragment key={nodeKey}>
                <button
                    type="button"
                    className={[
                        "search-selector-filter-node",
                        isSelected ? "is-active" : "",
                    ].filter(Boolean).join(" ")}
                    style={{"--filter-depth": depth}}
                    title={node.name}
                    onClick={() => onSelect(node)}
                >
                    {hasChildren ? (
                        <span
                            className="search-selector-filter-node-toggle"
                            onClick={(e) => {
                                e.stopPropagation();
                                onToggleNode(nodeKey);
                            }}
                            role="presentation"
                        >
                            <ChevronIcon open={isExpanded} />
                        </span>
                    ) : (
                        <span className="search-selector-filter-node-spacer" />
                    )}
                    <span className="search-selector-filter-node-icon">
                        <SearchSelectorCategoryIcon type="folder" />
                    </span>
                    <span className="search-selector-filter-node-label">{node.name}</span>
                </button>
                {hasChildren && isExpanded ? (
                    <FilterTreeNodes
                        nodes={node.children}
                        depth={depth + 1}
                        selectedDeptId={selectedDeptId}
                        expandedNodeIds={expandedNodeIds}
                        onToggleNode={onToggleNode}
                        onSelect={onSelect}
                    />
                ) : null}
            </React.Fragment>
        );
    });
}

export default function ApproveDeptTree({data, loading, selectedDeptId, onSelect}) {
    const [expandedNodeIds, setExpandedNodeIds] = useState({});

    const handleToggleNode = (nodeKey) => {
        setExpandedNodeIds((prev) => ({...prev, [nodeKey]: !prev[nodeKey]}));
    };

    const handleSelect = (node) => {
        onSelect(selectedDeptId === node.id ? undefined : node);
    };

    if (loading) {
        return <div className="search-selector-filter-loading">불러오는 중…</div>;
    }

    return (
        <div className="search-selector-filter-section" data-entity="department">
            <FilterTreeNodes
                nodes={data ?? []}
                depth={0}
                selectedDeptId={selectedDeptId}
                expandedNodeIds={expandedNodeIds}
                onToggleNode={handleToggleNode}
                onSelect={handleSelect}
            />
        </div>
    );
}
